import React from 'react';
import {CLOSE, useMuseumFilterDispatch, useMuseumFilterState} from "./museumFilterContext";
import {Backdrop, Modal, Paper, Slide} from "@mui/material";


export const ModalMuseumFilter = ({children}) => {
    const {open} = useMuseumFilterState();
    const dispatch = useMuseumFilterDispatch();

    const onClose = () => dispatch({type: CLOSE});

    return (
        <Modal
            open={open}
            onClose={onClose}
            BackdropComponent={Backdrop}
            sx={{
                display: "flex",
                flexDirection: "row-reverse"
            }}
        >
            <Slide
                in={open}
                direction={"left"}
            >
                <Paper
                    sx={{
                        width: 300,
                        outline: 'none',
                        height: "100%",
                        overflowY: "auto",
                        zIndex: theme.zIndex.modal + 1
                    }}
                >
                    {children}
                </Paper>
            </Slide>

        </Modal>
    )
}